import React from 'react'

import 'bootstrap/dist/css/bootstrap.min.css'
import './endfooter.css'
import facebookIcon from '../../static/images/twitter.png'
import instagramIcon from '../../static/images/insta.png'
import linkedinIcon from '../../static/images/in.png'
const Footer = () => {
	return ( //rgb(117, 36, 36)
		<footer className="main-footer text-white p-4 w-full">
			<div className="container">
				<div className="row">
					{/* About Section */}
					<div className="col-md-3">
						<h5>About Us</h5>
						<p>Falcon provides the best services to deliver 
							the shipments of all kind at customer's doorstep
						</p>
					</div>

					{/* Quick Links */}
					<div className="col-md-3">
					</div>

					{/* Contact Info */}
					<div className="col-md-3">
						<h5>Contact Us</h5>
						<ul className="list-unstyled">
							<li>Phone: 058 6282600</li>
							<li>Email: admin@falcondelivery.ae</li>
							<li>Address: Jurf 1, Behind Last Chance Market, UAE, Ajman - 94850</li>
						</ul>
					</div>

					{/* Social Media Icons */}
					<div className="col-md-3">
						<h5>Follow Us</h5>
						<div style={{display: 'flex', flexDirection: 'row'}}>
						<a href="https://twitter.com/?lang=en" className="text-white me-2">
							<img style={{ height: '45px' }} src={facebookIcon} alt="Facebook" />
						</a>
						<a href="https://www.instagram.com/" className="text-white me-2">
							<img style={{ height: '45px' }} src={instagramIcon} alt="Instagram" />
						</a>
						<a href="https://pk.linkedin.com/" className="text-white">
							<img style={{ height: '45px' }} src={linkedinIcon} alt="LinkedIn" />
						</a>
						</div>
					</div>
				</div>
					<br/>
				{/* Copyright */}
				<div className="row mt-3">
					<div className="col text-center">
						© 2024 Falcon Delivery Services. All rights reserved.
					</div>
				</div>
				<br/>
			</div>
		</footer>
	)
}

export default Footer
